export const apiUrl = "https://bol.mondial-assistance.gr/SamsungEWapi/api/prod";
